export type AdminSession = { authenticated: true; username: string; csrfToken: string; expiresAt: string };

let csrfToken = '';
export function setCsrfToken(value = '') { csrfToken = value; }

async function responseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const error = Object.assign(new Error(body.error || `HTTP ${response.status}`), { status: response.status, code: body.code });
    throw error;
  }
  if (response.status === 204) return undefined as T;
  return response.json();
}

export async function api<T = any>(url: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (!(options.body instanceof FormData)) headers.set('content-type', 'application/json');
  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(String(options.method || 'GET').toUpperCase()) && csrfToken) headers.set('x-csrf-token', csrfToken);
  const response = await fetch(`/api${url}`, { ...options, credentials: 'same-origin', headers });
  if (response.status === 401) window.dispatchEvent(new CustomEvent('suri:unauthorized'));
  return responseJson<T>(response);
}

export async function getSession(): Promise<AdminSession> {
  const response = await fetch('/api/auth/session', { credentials: 'same-origin', cache: 'no-store' });
  const session = await responseJson<AdminSession>(response);
  setCsrfToken(session.csrfToken);
  return session;
}

export async function login(username: string, password: string): Promise<AdminSession> {
  const response = await fetch('/api/auth/login', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ username, password }) });
  const session = await responseJson<AdminSession>(response);
  setCsrfToken(session.csrfToken);
  return session;
}

export async function logout() {
  const response = await fetch('/api/auth/logout', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json', 'x-csrf-token': csrfToken }, body: '{}' });
  await responseJson<void>(response);
  setCsrfToken();
}

export type Project = {
  id: string; name: string; source: string; status: string; render_status: string; upload_status: string;
  scheduled_at?: string; youtube_url?: string; last_error?: string; metadata: Record<string, any>;
  audio_asset_id?: string; image_asset_id?: string; video_asset_id?: string; channel_id?: string;
  render_job_id?: string; render_job_status?: string; render_progress?: number; render_phase?: string;
};

export type RenderJob = {
  id: string; projectId: string; projectName?: string; status: string; progress: number; phase: string;
  error?: string | null; createdAt: string; updatedAt: string; startedAt?: string | null; finishedAt?: string | null;
  elapsedSeconds: number; etaSeconds?: number | null; queuePosition?: number | null; attempt: number;
  ffmpegSpeed?: number | null; ffmpegFps?: number | null; ffmpegFrame?: number | null;
  originJobId?: string | null; outputAssetId?: string | null; outputUrl?: string | null; thumbnailUrl?: string | null;
  duplicatePrevented?: boolean;
};

export const sourceLabel: Record<string, string> = { voice_agent: 'Suri Voice Agent', video_agent: 'Suri Video Agent', manual: 'Tải lên thủ công' };
